<template>
  <div class="order">
    <div class="search mt20">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="买家昵称" class="iblock">
          <el-input v-model="form.name" class="w300" placeholder="请输入买家昵称"></el-input>
        </el-form-item>
        <el-row>
          <el-form-item label="下单时间" class="iblock">
            <el-date-picker
              v-model="form.date"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getDate"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="订单状态" class="iblock ml20">
            <el-select v-model="form.status" class="w300" clearable placeholder="请选择订单状态">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <el-form-item label class="operation">
          <el-button type="primary" @click="screen()">筛选</el-button>
          <el-button type="primary" @click="Reset()">重置</el-button>
          <el-button type="primary" :disabled="form.date.length>0?false:true" @click="exportOrder()">导出订单</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- //订单列表 -->
    <el-row class="t-header">
      <el-col :span="6">商品名称</el-col>
      <el-col :span="3">下单时间</el-col>
      <el-col :span="3">订单状态</el-col>
      <el-col :span="2">单价</el-col>
      <el-col :span="2">数量</el-col>
      <el-col :span="2">实付金额</el-col>
      <el-col :span="2">买家昵称</el-col>
      <el-col :span="4">操作</el-col>
    </el-row>
    <el-row
      class="content"
      v-if="resultData.list&&resultData.list.length>0"
      v-loading="tableLoading"
    >
      <el-row class="content-item" v-for="(item,index) in resultData.list" :key="index">
        <!-- <p>具备强感知能力的固态面阵激光雷达技解析|车辆感知第七讲</p> -->
        <el-row class="title">
          <el-col :span="9">
            <span class="label-title">订单号：{{item.order_no}}</span>
          </el-col>
          <el-col :span="11">
            <span class="label-title">支付方式：
              <span v-show="item.pay_mode==1">微信支付</span>
              <span v-show="item.pay_mode==2">支付宝支付</span>
            </span>
          </el-col>
          <el-col :span="3">
            <span class="label-title">操作方式：自有服务好账户</span>
          </el-col>
        </el-row>
        <el-row class="info">
          <el-col :span="6">{{item.goods_name}}</el-col>
          <el-col :span="3">{{item.pay_at}}</el-col>
          <el-col :span="3">
            <span v-show="item.pay_state==1">待支付</span>
            <span v-show="item.pay_state==2">已支付</span>
            <span v-show="item.pay_state==3">已退款</span>
            <span v-show="item.pay_state==4">支付失败</span>
          </el-col>
          <el-col :span="2">{{item.goods_price}}</el-col>
          <el-col :span="2">{{item.goods_quantity}}</el-col>
          <el-col :span="2">{{item.total_amount}}</el-col>
          <el-col :span="2">{{item.user_nick_name}}</el-col>
          <el-col :span="4">
            <span class="blue cp" @click="orderDecript(item)">订单详情</span>
          </el-col>
        </el-row>
      </el-row>
    </el-row>

    <div class="tc mt40">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="Number(search.page)"
        :page-size="Number(search.size)"
        layout="total, prev, pager, next"
        :total="Number(resultData.count)"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
const FORM_INIT=function(){
  return{
       name: "",
       status: "0",
       date: []
  }
}
//获取信息采集的记录
import { _userOrderBuy } from "@/api/order.js";

export default {
  created() {
    this.userOrderBuy();
  },
  components: {},
  data() {
    return {
      form:FORM_INIT(),
      options: [
        {
          value: "0",
          label: "全部"
        },
        {
          value: "1",
          label: "待支付"
        },
        {
          value: "2",
          label: "已完成"
        },
        {
          value: "3",
          label: "已退款"
        },
        {
          value: "4",
          label: "支付失败"
        }
      ],
      tableLoading: false,
      search: {
        page: 1,
        size: 10
      },
      // name type num money date
      resultData: {}
    };
  },
  methods: {
    screen() {
      this.search.page=1;
      this.userOrderBuy();
    },
    //重置按钮
    Reset() {
      this.search.page=1;
      this.form=FORM_INIT();
      this.userOrderBuy();
    },
    exportOrder() {
          // start_time:this.form.date[0],
          // end_time:this.form.date[1],
      window.open(`/admin/excel/order?start_time=${this.form.date[0]}&end_time=${this.form.date[1]}`,'_self')
    },
    getDate(val) {
      console.log(val);
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val;
      this.userOrderBuy();
    },
    reply(item) {
      this.privateDialogVisible = true;
    },
    //获取订单信息
    userOrderBuy() {
      this.tableLoading = true;
      _userOrderBuy({
        params: {
          page: this.search.page,
          size: this.search.size,
          keywords:this.form.name,
          start_time:this.form.date[0]?this.form.date[0]:'',
          end_time:this.form.date[1]?this.form.date[1]:'',
          pay_state:this.form.status
        }
      }).then(res => {
        this.tableLoading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //订单详情
    orderDecript(item) {
      let routeData = this.$router.resolve({
        path: `/payment/order/descript/${item.order_id}`
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style scoped lang="less">
.order {
  .operation {
    button {
      margin-right: 20px;
    }
  }
  .t-header {
    margin-top: 20px;
    background-color: @table-bg;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    font-weight: bold;
  }
  .content {
    .content-item {
      .title {
        height: 40px;
        line-height: 40px;
        color: @gray;
        padding: 0 20px;
        overflow: hidden;
      }
      .info {
        background-color: #fefefe;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        // line-height: 60px;
        padding: 0 20px;
        font-weight: 500;
        div{
          padding:20px 0;
        }
      }
    }
  }
}
</style>